export const CATEGORY_MUTATION = {
  LIST_0_MUTATION: "LIST_0_MUTATION_CATEGORY_MUTATION",
  LIST_1_MUTATION: "LIST_1_MUTATION_CATEGORY_MUTATION",
  LIST_2_MUTATION: "LIST_2_MUTATION_CATEGORY_MUTATION",
};
